import { useCallback } from 'react';
import { useTreeContext } from '../contexts/TreeContext';
import { useExpansionSet } from '../contexts/NodeExpansionSet';

type TreeNodeToolbarProps = {
  nodeId: number;
};
export function TreeNodeToolbar({ nodeId }: TreeNodeToolbarProps) {
  const { insertAtNode, deleteNode } = useTreeContext();
  const { expand } = useExpansionSet();

  const createInside = useCallback(() => {
    insertAtNode(nodeId, 'inside');
    expand(nodeId);
  }, [insertAtNode]);

  return (
    <div>
      <button onClick={() => insertAtNode(nodeId, 'before')}>
        Create Before
      </button>
      <button onClick={() => insertAtNode(nodeId, 'after')}>
        Create After
      </button>
      <button onClick={createInside}>Create Inside</button>
      <button onClick={() => deleteNode(nodeId)}>Delete</button>
    </div>
  );
}
